export const ExtendedAbsenceTypeInput = {
  ANNUALLEAVE: 'AnnualLeave',
  ANNUALLEAVE_HOURLY: 'AnnualLeaveHourly',
  CAREGIVINGLEAVE: 'CaregivingLeave',
  CHILDCARELEAVE: 'ChildCareLeave',
  DUETOFORCEMAJEURELEAVE: 'DueToForceMajeureLeave',
  FLEXTIMELEAVE: 'FlextimeLeave',
  MATERNITYLEAVE: 'MaternityLeave',
  OUTOFOFFICE: 'OutOfOffice',
  PAIDLEAVE: 'PaidLeave',
  PARENTALLEAVE: 'ParentalLeave',
  PATERNITYLEAVE: 'PaternityLeave',
  SICKFAMILYMEMBERCARELEAVE: 'SickFamilyMemberCareLeave',
  SICKLEAVE: 'SickLeave',
  SPECIALLEAVE: 'SpecialLeave',
  UNPAIDLEAVE: 'UnpaidLeave',
} as const;

export type ExtendedAbsenceTypeInputType = typeof ExtendedAbsenceTypeInput[keyof typeof ExtendedAbsenceTypeInput];

export enum CellState {
  free = 'free',
  taken = 'taken',
  pending = 'pending',
  approved = 'approved',
  assigned = 'assigned',
  outOfWindow = 'outOfWindow',
}
